import { useEffect, useState } from "react";
import styles from "./addBooking.module.css";
import { Checkbox, FormControlLabel, FormControl, InputLabel, MenuItem, Select, TextField, Dialog, Alert, Snackbar, Button, Autocomplete, CircularProgress } from "@mui/material";
import axios from "axios";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { authData } from "../../../components/GetAuth";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Loader from "../../../components/Loader";
import DeliveryProductComponent from "./component/DeliveryProductComponent";
import debounce from "lodash/debounce";
import { useMemo } from "react";
import AddCustomerForm from "../../../components/popups/AddCustomerForm";

const Step1 = ({ saveStep1Data, bookingData, setCustomerEmail }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [isRegCompany, setIsRegCompany] = useState("");
  const [noOfItems, setNoOfItems] = useState(0);
  const [itemTotal, setItemTotal] = useState(0);
  const [allTotal, setAllTotal] = useState(0);
  const [formOpen, setFormOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [discountVal, setDiscountVal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [referralAmount, setReferralAmount] = useState(0);
  const [referralDiscount, setReferralDiscount] = useState(0);
  const VATCharge = 0;
  const InsuranceCharge = 0;

  const [customerList, setCustomerList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectLoading, setSelectLoading] = useState(false);

  const { register, handleSubmit, control, setValue, getValues, formState: { errors }, clearErrors, watch } = useForm({
    mode: "onChange",
    defaultValues: {
      customer: null,
      customer_id: "",
      registered_company: "",
      company_shipping: "",
      insurance: "",
      pickup_date: dayjs(),
      notes: "",
      delivery_products: bookingData?.delivery_products ? bookingData?.delivery_products : [{ category_id: "", item_id: "", item_name: "", total: "", quantity: "", price: "", is_item: true }],
      products: bookingData?.products ? bookingData?.products : [{ category_id: "", item_id: "", item_name: "", total: "", is_item: true }]
    }
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "delivery_products",
  });

  useEffect(() => {
    if (bookingData) {
      setDiscountVal(bookingData?.discountVal);

      let discountTemp = 0;

      if (typeof (bookingData?.discountAmount) !== 'undefined') {
        setDiscountAmount(bookingData?.discountAmount);
        discountTemp = bookingData?.discountAmount;
      }

      if (bookingData?.customer_id) {
        customerById(bookingData?.customer_id);
      }

      setValue(`customer_id`, bookingData?.customer_id);
      setValue(`registered_company`, bookingData?.registered_company);
      setValue(`insurance`, bookingData?.insurance);
      setValue(`notes`, bookingData?.notes);
      setValue(`pickup_date`, dayjs(bookingData?.pickup_date));

      if (bookingData?.registered_company === "Yes") {
        setValue(`company_name`, bookingData?.company_name);
        setValue(`company_shipping`, bookingData?.company_shipping);
      }
      setIsRegCompany(bookingData?.registered_company);

      let allTotalTemp = 0;

      if (bookingData?.delivery_products) {
        let noOfI = 0;
        let itemT = 0;
        bookingData?.delivery_products.forEach((i) => {
          if (i?.total !== "") {
            noOfI++;
            itemT += parseFloat(i?.total);
          }
        });
        setNoOfItems(noOfI);
        setItemTotal(itemT);
        allTotalTemp += itemT;

        replace(bookingData?.delivery_products);
      }

      setAllTotal(allTotalTemp + VATCharge + InsuranceCharge - discountTemp);
    }
  }, [bookingData, setValue, replace]);

  const onSubmit = (data) => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });

    let pListTemp = data?.products?.map(i => {
      if (i?.category_id === 0) {
        return { ...i, item_name: 'Other- ' + i?.item_name };
      }
      return i;
    });

    data = { ...data, products: pListTemp, pickup_date: dayjs(data?.pickup_date).format("YYYY-MM-DD"), itemTotal: itemTotal, discountVal: discountVal, discountAmount: discountAmount, referralDiscount: referralDiscount };

    let deliveryItemList = [];
    if (data?.is_delivery) {
      deliveryItemList = data?.delivery_products?.map(i => {
        if (i?.category_id === 0) {
          return { ...i, item_name: 'Other- ' + i?.item_name };
        }
        return i;
      });
      data = { ...data, delivery_products: deliveryItemList };
    }
    saveStep1Data(data);
  };

  const cngDeliveryProductVal = () => {
    let products = getValues("delivery_products");
    let noOfI = 0;
    let itemT = 0;
    let discountTemp = 0;
    let discountTemp2 = 0;
    products.forEach((i) => {
      if (i?.total !== "") {
        noOfI++;
        itemT += parseFloat(i?.total);
      }
    });
    setNoOfItems(noOfI);
    setItemTotal(itemT);
    if (discountVal) {
      discountTemp = ((itemT * discountVal) / 100);
      if (discountTemp > parseInt(discountTemp)) {
        discountTemp = discountTemp.toFixed(2);
        discountTemp = parseFloat(discountTemp);
      }
      setDiscountAmount(discountTemp);
    }

    if (referralAmount) {
      var subtotaltemp = itemT - discountTemp;
      if (subtotaltemp >= referralAmount) {
        discountTemp2 = referralAmount;
      } else {
        discountTemp2 = subtotaltemp;
      }
      setReferralDiscount(discountTemp2);
    }

    setAllTotal(itemT + VATCharge + InsuranceCharge - discountTemp - discountTemp2);
  }

  const delDeliveryItems = (index) => {
    if (fields.length <= 1) return false;
    remove(index);
    cngDeliveryProductVal();
  };

  const onSubmitAddForm = (data) => {
    customerById(data?.id);
    setValue(`customer_id`, data?.id);
    setIsRegCompany(data?.registered_company);
    setValue("registered_company", data?.registered_company);
    setValue("company_name", data?.company_name);
    setValue("company_shipping", data?.company_shipping);
  };

  const fetchCustomers = async (search = "", pageNo = 1) => {
    if (selectLoading) return;

    setSelectLoading(true);

    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + "v1/async-customer-dd-list", {
        headers: { Authorization: `Bearer ${API_TOKEN}` },
        params: { search: search, page: pageNo },
      });

      if (response.data.status === "SUCCESS") {
        const newData = response.data.data;

        setCustomerList(prev =>
          pageNo === 1 ? newData : [...prev, ...newData]
        );

        setHasMore(pageNo < response.data.last_page);
      }
    } catch (err) { }

    setSelectLoading(false);
  }

  const customerById = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + "v1/customers/" + id, {
        headers: { Authorization: `Bearer ${API_TOKEN}` }
      });

      if (response.data.status === "SUCCESS") {
        const newData = response.data.data;

        setCustomerList([newData]);
        setValue('customer', newData);
      }
    } catch (err) { }
  }

  const debounceSearch = useMemo(() =>
    debounce((value) => {
      setPage(1);
      setHasMore(true);
      fetchCustomers(value, 1);
    }, 400), []);

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.StepOneForm}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className={`${styles.StepOneFormRow}`}>
            <div className={`${styles.StepOneFormFull}`}>
              <div className={styles.FormFullGroup} style={{ display: 'unset' }}>
                <div className={`${styles.AltConSec}`} style={{ width: '100%' }}>
                  <FormControl fullWidth>
                    <Controller
                      name="customer"
                      control={control}
                      rules={{ required: "Please select customer" }}
                      render={({ field, fieldState }) => (<Autocomplete
                        options={customerList}
                        loading={selectLoading}
                        getOptionLabel={(option) =>
                          option ? `${option.name} (${option.phone}) ${option.address}` : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.id === value?.id
                        }
                        onInputChange={(event, newInputValue) => {
                          setSearchText(newInputValue);
                          debounceSearch(newInputValue);
                        }}
                        onOpen={() => {
                          if (customerList.length === 0) {
                            fetchCustomers("", 1);
                          }
                        }}
                        ListboxProps={{
                          onScroll: (event) => {
                            const listboxNode = event.currentTarget;

                            const scrollBottom =
                              listboxNode.scrollTop + listboxNode.clientHeight >=
                              listboxNode.scrollHeight - 10;

                            if (scrollBottom && hasMore && !selectLoading) {
                              const nextPage = page + 1;
                              setPage(nextPage);
                              fetchCustomers(searchText, nextPage);
                            }
                          },
                        }}
                        value={field.value || null}
                        onChange={(_, data) => {
                          field.onChange(data);
                          if (data) {
                            setValue('customer_id', data?.id);

                            setCustomerEmail(data?.email);

                            let selCustomer = data;

                            setIsRegCompany(selCustomer?.registered_company);
                            setValue("registered_company", selCustomer?.registered_company);
                            setValue("company_name", selCustomer?.company_name);
                            setValue("company_shipping", selCustomer?.company_shipping);
                            setDiscountVal(selCustomer?.discount_val);
                            setReferralAmount(selCustomer?.referral_amount);

                            let discountTemp = 0;
                            let discountTemp2 = 0;
                            if (selCustomer?.discount_val) {
                              discountTemp = ((itemTotal * selCustomer?.discount_val) / 100);
                              if (discountTemp > parseInt(discountTemp)) {
                                discountTemp = discountTemp.toFixed(2);
                                discountTemp = parseFloat(discountTemp);
                              }
                            }
                            setDiscountAmount(discountTemp);

                            if (selCustomer?.referral_amount) {
                              var subtotaltemp = itemTotal - discountTemp;
                              if (subtotaltemp >= selCustomer?.referral_amount) {
                                discountTemp2 = selCustomer?.referral_amount;
                              } else {
                                discountTemp2 = subtotaltemp;
                              }
                            }
                            setReferralDiscount(discountTemp2);

                            setAllTotal(itemTotal + VATCharge + InsuranceCharge - discountTemp - discountTemp2);

                            clearErrors();
                          } else {
                            setValue('customer_id', "");

                            setIsRegCompany("");
                            setValue("registered_company", "");
                            setValue("company_name", "");
                            setValue("company_shipping", "");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Customer*"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {selectLoading && <CircularProgress size={20} />}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />)}
                    />
                  </FormControl>
                  <Button type="button" onClick={(e) => { setFormOpen(true); setEditData(null); }} className={`${styles.AddBU}`}>Add</Button>
                </div>
                {errors.customer && (<span className={`${styles.ErrorM}`}>{errors?.customer?.message}</span>)}
              </div>

              <div className={styles.FormHalfGroup}>
                <FormControl fullWidth>
                  <InputLabel>Do you have a registered company in UK?</InputLabel>
                  <Controller
                    control={control}
                    {...register("registered_company")}
                    render={({ field }) => (<Select
                      label="Do you have a registered company in UK?"
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        setIsRegCompany(e.target.value);
                      }}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>)}
                  />
                </FormControl>
              </div>

              <div className={styles.FormHalfGroup}>
                <FormControl fullWidth>
                  <InputLabel>Have you got insurance?</InputLabel>
                  <Controller
                    control={control}
                    {...register("insurance")}
                    render={({ field }) => (<Select {...field} label="Have you got insurance?">
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                      <MenuItem value="Not Interested">Not Interested</MenuItem>
                    </Select>)}
                  />
                </FormControl>
              </div>
            </div>

            {isRegCompany === "Yes" && <div className={`${styles.StepOneFormFull}`}>
              <div className={styles.FormHalfGroup}>
                <Controller
                  control={control}
                  {...register("company_name", { required: "This field is Required" })}
                  render={({ field }) => (<TextField {...field} label="If Yes, please mention the name of the company?*" variant="outlined" fullWidth />)}
                />
                {errors.company_name && (<span className={`${styles.ErrorM}`}>{errors?.company_name?.message}</span>)}
              </div>

              <div className={styles.FormHalfGroup}>
                <FormControl fullWidth>
                  <InputLabel>If Yes, are you shipping the goods in the name of the company?*</InputLabel>
                  <Controller
                    control={control}
                    {...register("company_shipping", {
                      required: "Please select one",
                    })}
                    render={({ field }) => (<Select label="If Yes, are you shipping the goods in the name of the company?*" {...field}>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>)}
                  />
                </FormControl>
                {errors.company_shipping && (<span className={`${styles.ErrorM}`}>{errors?.company_shipping?.message}</span>)}
              </div>
            </div>}

            <DeliveryProductComponent fields={fields} append={append.bind(this)} errors={errors} control={control} setValue={setValue.bind(this)} register={register} clearErrors={clearErrors.bind(this)} watch={watch.bind(this)} cngProductVal={cngDeliveryProductVal.bind(this)} delItems={delDeliveryItems.bind(this)} />


            <div className={`${styles.StepOneFormBig}`} >
              <div className={styles.StepOneFormFull}>
                <div className={styles.FormHalfGroup} style={{ flex: '1 1 220px' }}>
                  <Controller
                    control={control}
                    {...register("pickup_date", { required: "Please select pick up date" })}
                    render={({ field }) => (<DatePicker
                      {...field}
                      minDate={dayjs()}
                      label="Pickup Date"
                      format="DD/MM/YYYY"
                      slotProps={{ textField: { fullWidth: true } }}
                    />)}
                  />
                  {errors.pickup_date && (<span className={`${styles.ErrorM}`}>{errors?.pickup_date?.message}</span>)}
                </div>

                <div className={styles.FormHalfGroup} style={{ flex: '2 1 320px' }}>
                  <Controller
                    control={control}
                    {...register("notes")}
                    render={({ field }) => (<TextField {...field} label="Booking Notes" variant="outlined" multiline rows={4} fullWidth />)}
                  />
                </div>
              </div>

              <div>
                <FormControlLabel
                  className={`${styles.CheckBox} CheckBox`}
                  label="I have read and agree to the prohibited & restricted items list*"
                  control={<Checkbox {...register("is_accept", { required: true })} />}
                />
                {errors?.is_accept && (<p className={`${styles.ErrorM}`}>Please accept terms & condition</p>)}
              </div>
            </div>

            <div className={`${styles.StepOneFormSmall}`}>
              <ul className={`${styles.CostUL}`}>
                <li>
                  <p className={`${styles.CostTitle}`}>No of Items:</p>
                  <p className={`${styles.CostNo}`}>{noOfItems}</p>
                </li>
                <li>
                  <p className={`${styles.CostTitle}`}>Item Subtotal:</p>
                  <p className={`${styles.CostNo}`}>
                    £{itemTotal?.toFixed(2)}
                  </p>
                </li>
                {discountVal > 0 && <li>
                  <p className={`${styles.CostTitle}`}>Membership Discount({discountVal}%):</p>
                  <p className={`${styles.CostNo}`}>
                    -£{discountAmount.toFixed(2)}
                  </p>
                </li>}
                {referralDiscount > 0 && <li>
                  <p className={`${styles.CostTitle}`}>Referral Discount:</p>
                  <p className={`${styles.CostNo}`}>
                    -£{referralDiscount.toFixed(2)}
                  </p>
                </li>}
                <li>
                  <p className={`${styles.CostTitle}`}>Total VAT:</p>
                  <p className={`${styles.CostNo}`}>£0.00</p>
                </li>
                <li>
                  <p className={`${styles.CostTitle}`}>Insurance Charges:</p>
                  <p className={`${styles.CostNo}`}>£0.00</p>
                </li>
                <li>
                  <p className={`${styles.CostTitle} ${styles.Big}`}>Total:</p>
                  <p className={`${styles.CostNo} ${styles.Big}`}>£{allTotal?.toFixed(2)}</p>
                </li>
              </ul>
            </div>

            <div className={`${styles.StepBUSec}`}>
              <button className={`${styles.Next}`} type="submit">Next</button>
            </div>
          </div>
        </LocalizationProvider >
      </form >
    </div >

    <Dialog open={formOpen} onClose={(e) => setFormOpen(false)} fullWidth maxWidth="sm">
      <AddCustomerForm onSubmitAddForm={onSubmitAddForm.bind(this)} setFormOpen={setFormOpen.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={editData} />
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
};

export default Step1;